export const PREACRIS_ONLINE_FORM = 'preacris';
export const EMPTY_VALUE = '';
export const TAB_INDEX = '1000';

export const PREACRIS_ONLINE_FORM_INITIAL_VALUES = {
  stateHob: EMPTY_VALUE,
  countyHob: EMPTY_VALUE,
  documentDescription: EMPTY_VALUE,
  cmtdocId: EMPTY_VALUE,
  driversData: EMPTY_VALUE,
  xdetailsData: EMPTY_VALUE,
};

export enum PreacrisFormLabels {
  STATE = 'State',
  COUNTY = 'County',
  CMT = 'Document Type',
}
export enum LocationFormNames {
  STATE = 'stateHob',
  COUNTY = 'countyHob',
  CMT = 'documentDescription',
  /*STATE = 'hobCodes.stateHob',
  COUNTY = 'hobCodes.countyHob', 
  CMT = 'hobCodes.countyHob',*/
}
export enum PreacrisFormPlaceholders {
  STATE = 'Choose State',
  COUNTY = 'Choose County',
  CMT = 'Choose Service',
}

export enum SearchTypeFormNames {
  DRIVERS_SEARCH = 'driversSearch',
  HOB_CODES = 'hobCodes',
}

export enum PreacrisSavedFormFieldNames {
  STATE = 'preacrisSavedFormFieldState',
  COUNTY = 'preacrisSavedFormFieldCounty',
  CMT = 'preacrisSavedFormFieldCmt',
}
